import isNil from 'lodash/isNil';

import { FieldType } from '@/catalog/constants/fieldTypes';
import { Field } from '@/catalog/types/field';
import { ALL_CONTEXTS } from '@/common/constants/context';
import { SetupPresetGroupType } from '@/media/entity/SetupPresetGroup';
import MetricScaleContainer from '@/metric/components/MetricScaleContainer/MetricScaleContainer';
import OptMetricBar from '@/metric/components/OptMetricBar/OptMetricBar';
import Diamond from '@/product/entity/Diamond';

export const FIELD_BRILLIANCE_V2: Field = {
  key: 'brilliance.rg2',
  label: 'Brilliance v2',
  fullLabel: 'Brilliance v2',
  type: FieldType.Metric,
  spGroupId: SetupPresetGroupType.Office,
  icon: 'metrics-brilliance',
  getValue(p) {
    if (p instanceof Diamond && p.brightnessMetric) {
      return p.brightnessMetric.rg2;
    }

    return null;
  },
  getText(p) {
    if (p instanceof Diamond && p.brightnessMetric) {
      return p.brightnessMetric.hr;
    }

    return null;
  },
  render(p, { ratio, size, label, icon, metricDataDecorator, metricClassName, isMetricInCard } = {}) {
    if (p instanceof Diamond) {
      return (
        <OptMetricBar
          cutShapeId={p.cutShapeId}
          metric={p.brightnessMetric}
          metricDataDecorator={metricDataDecorator}
          ratio={ratio}
          rgFieldName="rg2"
          type="brilliance2"
          valFieldName="val2"
        >
          {(scale, abs) => (
            <MetricScaleContainer
              abs={abs}
              icon={icon}
              className={metricClassName}
              inCard={isMetricInCard}
              isMetricCalculated={!isNil(p.brightnessMetric?.val2)}
              label={label}
              scale={scale}
              size={size}
            />
          )}
        </OptMetricBar>
      );
    }

    return null;
  },
  iteratee(p) {
    if (p instanceof Diamond && p.brightnessMetric) {
      return p.brightnessMetric.val2;
    }

    return null;
  },
  contexts: ALL_CONTEXTS,
};
